import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import LogoArea from './Logo.style';

interface LogoProps {
  className?: string;
  withLink?: boolean;
  linkTo?: string;
  src?: string;
  title?: string;
}

const Logo: React.FC<LogoProps> = ({ className, withLink, linkTo, src }) => {
  return (
    <LogoArea className={className}>
      {withLink && linkTo ? (
        <NavLink to={linkTo}>
          {src ? (
            <img
              style={{ width: 145, opacity: 1 }}
              src={src}
              alt="Profile Icon."
            />
          ) : (
            <img
              style={{ width: 145, marginTop: 10, opacity: 1 }}
              src="https://bid-your-stay.s3.ap-south-1.amazonaws.com/assets/images/logo/unpaqd_logo.svg"
              alt="Unpaqd Logo."
            />
          )}
        </NavLink>
      ) : (
        <Fragment>
          {src ? (
            <img
              style={{ opacity: 1 }}
              width="145"
              src={src}
              alt="Profile Icon."
            />
          ) : (
            <img
              style={{ width: 145, marginTop: 10, opacity: 1 }}
              width="145"
              src="https://bid-your-stay.s3.ap-south-1.amazonaws.com/assets/images/logo/unpaqd_logo.svg"
              alt="Unpaqd Logo."
            />
          )}
        </Fragment>
      )}
    </LogoArea>
  );
};



export default Logo;
